import guest from "./guest";
import user from "./user";
import vendor from "./vendor";

export default guest.concat(user, vendor);